import React from 'react'
import { Services } from '@/services/services'
import { Translates } from '@/services/repository/i18n'
import { useModal } from '../modal/Modal'

import './Langs'
import { UserSession } from '@/services/repository/users'

export type LangUpdater = (langCode: string) => void

export const LangsPopup = ({ services, translates, onClose, currentCode, update }: { services: Services, translates: Translates, onClose: () => void, currentCode: string, update: LangUpdater }) => {
  // const defaultLangCode = services.i18n.defaultLang()

  function langRow(title: string, code: string) {
    return <li onClick={() => {
      update(code)
      window.location.reload();
      onClose()
    }} className={currentCode === code ? 'current' : ''}>
      <div className='title'>{title}</div>
      <img src={`/public/img/flags/${code}.svg`} />
    </li>
  }
  return <div className='layout-navbar-langs'>
    <ul>
      {Object.values(services.i18n.langData()).map((lang) => langRow(lang.title, lang.id))}
    </ul>
  </div>
}

export const LangsButton = ({ services, translates }: { services: Services, translates: Translates}) => {
  const { openModal } = useModal()

  return <div className='current-lang' onClick={() => openModal((props) => LangsPopup({ ...props, translates, services, currentCode: services.i18n.defaultLang(), update: (code:string) => {
    services.i18n.setDefaultLang(code)
  }}))}>
    <div className='title'>{translates.for('dicts.langs.' + services.i18n.defaultLang())}</div>
    <img src={`/public/img/flags/${services.i18n.defaultLang()}.svg`} />
  </div>
}

export const UserLangsButton = ({ services, session, translates }: { services: Services, session: UserSession, translates: Translates}) => {
  const { openModal } = useModal()

  return <div className='current-lang' onClick={() => openModal((props) => LangsPopup({ ...props, translates, services, currentCode: session.user.lang, update: (code:string) => {
    services.i18n.setDefaultLang(code)
    services.session.setLang(code)
  }}))}>
    <div className='title'>{translates.for('dicts.langs.' + session.user.lang)}</div>
    <img src={`/public/img/flags/${session.user.lang}.svg`} />
  </div>
}

export const CommunalLangsButton = ({ services, session, translates }: { services: Services, session?: UserSession, translates: Translates}) => {
  if(session) {
    return <UserLangsButton session={session} services={services} translates={translates} />
  }
  return <LangsButton services={services} translates={translates} />
}